import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import {SLICE_BASE_NAME} from './constants'
import {updateAccount} from '@/services/apiUsers'

export type Role = {
    id: number,
    name: string
    permissions: string[]
}

export type UserState = {
    name?: string
    avatarUrl?: string
    permissions: string[]
    roles?: Role[]
    navigation: any,
    dashboard?: object,
    wallpaper?: object,
}

const initialState: UserState = {
    name: '',
    avatarUrl: '',
    permissions: [],
    navigation: [],
    wallpaper: undefined,
    dashboard: {
        xl: [],
        lg: [],
        md: [],
        sm: [],
        xs: [],
        xxs: [],
    },
}

export const updateDashboard = createAsyncThunk(
    'user/updateDashboard',
    async (dashboard: any, thunkAPI) => {
        const formData = new FormData();
        formData.append("dashboard", JSON.stringify(dashboard));
        const response = await updateAccount(formData)
        thunkAPI.dispatch(setDashboard(dashboard));
        return response.data
    }
)

export const updateWallpaper = createAsyncThunk(
    'user/updateWallpaper',
    async (wallpaper: any, thunkAPI) => {
        const formData = new FormData();
        formData.append("wallpaper", wallpaper?.id);
        const response = await updateAccount(formData)
        thunkAPI.dispatch(setWallpaper(wallpaper));
        return response.data
    }
)

const userSlice = createSlice({
    name: `${SLICE_BASE_NAME}/user`,
    initialState,
    reducers: {
        setUser(state, action: PayloadAction<UserState>) {
            for (let key in action.payload)
                state[key] = action.payload[key];
            // state.name = action.payload?.name
            // state.avatarUrl = action.payload?.avatarUrl
            // state.permissions = action.payload?.permissions
            // state.roles = action.payload?.roles
        },
        setDashboard(state, action: PayloadAction<object>) {
            state.dashboard = action.payload
        },
        setWallpaper(state, action: PayloadAction<object>) {
            // console.log('action: ', action)
            state.wallpaper = action.payload
        },
        setNavigation(state, action: PayloadAction<any>) {
            // console.log('action: ', action)
            state.navigation = action.payload
        }
    },
})

export const {
    setUser,
    setDashboard,
    setWallpaper,
    setNavigation,
} = userSlice.actions
export default userSlice.reducer
